const config = require('../../config/runtime_config.js')

module.exports = [
	{
		path: 'avs_generator',
		name: 'AVS generator',
		component: () => import('@/pages/test/avs_generator/avsGenerator.vue'),
		meta: {
			label: 'AVS generator',
			icon: 'play_arrow',
			description: `Générateur de scripts avisynth (pour tester le composant et la classe)`,
			disabled: `${config._$ppt9qr}` === 'production'
		}
	},
	{
		path: 'sandbox',
		name: 'SandBox',
		component: () => import('@/pages/test/sandbox/sandbox.vue'),
		meta: {
			label: 'SandBox pour tests',
			icon: 'view_quilt',
			description: ``,
			disabled: `${config._$ppt9qr}` === 'production'
		}
	},
	{
		path: '/es',
		name: 'Elastic Search',
		component: () => import('@/pages/test/es/es.vue'),
		meta: {
			label: 'Elastic Search',
			icon: 'code',
			description: ``,
			disabled: `${config._$ppt9qr}` === 'production'
		}
	},
	{
		path: '/piman_test',
		name: 'Piman test',
		component: () => import('@/pages/test/piman/piman_test.vue'),
		meta: {
			label: 'Piman Test',
			icon: 'code',
			description: ``,
			disabled: `${config._$ppt9qr}` === 'production'
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/routes_tests.js